<template lang="pug">
div
  portal(to="title")
    .d-flex
      v-card(flat max-width="250px")
        v-select(
          v-model="selected"
          min-width="100"
          filled dense solo flat
          hide-details
          v-bind="selectProps"
        )
  v-row().mb-4
    v-col(cols=12 v-if="!$loader.isLoading && !courses.length")
      p Вы еще нигде не обучаетесь...
    v-col.mb-4(
      xl="3" lg="4" md="6" cols="12"
      v-for="(course, i) in courses"
      v-if="course.priority_user_prior_record"
      :key="course.id"
    )
      record-status-wrap(
        :user-record="course.priority_user_prior_record.user_record"
        v-slot:default="{ color, label, group }"
      )
        .d-flex.flex-column.fill-height
          .d-flex.pb-1.align-center
            v-avatar(size="12" :color="color || 'grey'").mr-2
            span.text-body-2 {{ label}}
            v-spacer
            tooltip-wrap(text="Вам что-то ответили")
              v-avatar(
                v-if="course.hasConsultationMessages"
                color="error" size="24"
              )
                v-icon(size="18" color="white") mdi-chat
          course-card(
            :course="course"
            :group="group"
            outlined
            study
          )

</template>

<script>
import { mapGetters } from 'vuex';
import SmartTable from '@/components/Global/SmartTable/index.vue';
import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';

export default {
  name: 'StudentsCourseList',
  components: {
    SmartTable,
    RecordStatusWrap,
    CourseCard,
  },
  data: () => ({
    loading: {
      contract: true,
    },
    selected: null,

    recordStatuses: [
      { name: 'Все', value: null },
      { name: 'Заявка', value: null },
      { name: 'Зачислен', value: null },
      { name: 'Аттестован', value: null },
      { name: 'Все', value: null },
    ],
    courses: [],
    headers: [
      { text: 'Контракт', value: 'contract' },
      { text: 'Наименование', value: 'title' },
      { text: 'Объем курса', value: 'duration' },
      { text: 'Статус', value: 'prior_record_status' },
      { text: 'Обучение', value: 'tasks' },
    ],
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      isTeacher: 'auth/isTeacher',
    }),
    selectProps() {
      const {
        items,
        itemValue,
        itemText,
      } = this.$conf.constantListProps('ATTESTATION_STATUSES');

      return {
        itemText,
        itemValue,
        items: [{ value: null, text: 'Все' }, ...items],
      };
    },

  },
  watch: {
    selected() {
      this.loadCourses();
    },
  },
  created() {
    this.loadCourses();
  },
  methods: {
    routeCourse(item) {
      this.$router.push({
        name: 'EducationCourseUnitList',
        params: { courseId: item.id, groupId: item.user_group_id },
      });
    },
    routeContract(item) {
      this.$router.push({
        name: 'ContractView',
        params: { id: item.contract.id },
        query: { courseId: item.id },
      });
    },
    async loadCourses() {
      this.loading.contract = true;
      const { items } = await this.$api.courses.index({
        'search[contracted_or_requested]': true,
        'search[prior_record_user_status]': this.selected,
        expand: 'user_passed,user_group_id,course_units,prior_record_status,contract_id,prior_records,priority_user_prior_record',
      });
      this.courses = items;
      this.getMassContracts();
      this.courses.forEach((i) => {
        i.fetchUnread({ userId: this.$user.data.id });
      });
    },
    async getMassContracts() {
      const { items } = await this.$api.contracts.getContractsModel({
        expand: 'transactions,qr_code,typical_contract,users,listener_preview_document,owner',
        'search[is_active]': true,
        'search[owner_id]': this.$user.data.id,
      });
      this.courses.forEach((course) => {
        course.contract = items.find(
          ({
            prior_record_id: priorRecordId,
          }) => (course?.priority_user_prior_record?.id === priorRecordId),
        );
      });
      this.loading.contract = false;
    },
  },
};
</script>
<style scoped>
.transition-all {
  transition: all .1s ease-in-out;
}
</style>
